import { render, staticRenderFns } from "./FavouriteMessages.vue?vue&type=template&id=2fa279f9&"
import script from "./FavouriteMessages.vue?vue&type=script&lang=js&"
export * from "./FavouriteMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports